module.exports = __webpack_public_path__ + "img/7_ava.2a0b0482.jpg";